export default __webpack_public_path__ + "static/media/hfilogo.bebe4af1.png";